import { createReducer, createAction } from '@reduxjs/toolkit'
import { CREATE_BET_SUCCESS, SET_TAB, TOGGLE_LIKED_OFFER_SUCCESS } from 'dealer-reducers'
import { ListOffer } from 'dealer-types'

export interface PaginatedOffersReducer {
  currentPage: number
  totalPages: number
  totalCount: number
  // Tab here is redundant is only needed for logic to tract when to reset current page to 1
  tab: string
  offers: ListOffer[]
}

const initialState: PaginatedOffersReducer = {
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
  tab: '',
  offers: []
}

export const SET_CURRENT_PAGE = createAction<{ currentPage: number }>('paginated_offers_reducer/set_current_page')

export const FETCH_OFFERS = createAction<{ refetch?: boolean } | undefined>('paginated_offers_reducer/fetch_offers')
interface FetchOffersSuccessPayload {
  offers: ListOffer[]
  totalPages: number
  totalCount: number
}
export const FETCH_OFFERS_SUCCESS = createAction<FetchOffersSuccessPayload>(
  'paginated_offers_reducer/fetch_offers_success'
)
export const FETCH_OFFERS_ERROR = createAction('paginated_offers_reducer/fetch_offers_error')

export const paginatedOffersReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SET_CURRENT_PAGE, (state, action) => {
      return { ...state, currentPage: action.payload.currentPage }
    })
    .addCase(FETCH_OFFERS_SUCCESS, (state, action) => {
      return {
        ...state,
        offers: action.payload.offers ?? [],
        totalPages: action.payload.totalPages ?? 0,
        totalCount: action.payload.totalCount ?? 0
      }
    })
    .addCase(FETCH_OFFERS_ERROR, (state) => {
      return { ...state }
    })
    .addCase(SET_TAB, (state, action) => {
      const currentPage = state.tab === action.payload.tab ? state.currentPage : 1
      return { ...state, tab: action.payload.tab, currentPage, offers: [] }
    })
    .addCase(TOGGLE_LIKED_OFFER_SUCCESS, (state, action) => {
      const changedOffers = state.offers.map((offer) => {
        if (offer.id === action.payload.offer_id) {
          return { ...offer, is_liked: action.payload.is_liked }
        }
        return offer
      })
      return { ...state, offers: changedOffers }
    })
    .addCase(FETCH_OFFERS, (state, action) => {
      if (action.payload?.refetch === true) {
        return { ...state, offers: [] }
      }
      return state
    })
    .addCase(CREATE_BET_SUCCESS, (state, action) => {
      const changedOffers = state.offers.map((offer) => {
        if (offer.hash_id === action.payload.offer.hash_id) {
          return { ...action.payload.offer, bar: action.payload.bar }
        }
        return offer
      })
      return {
        ...state,
        offers: changedOffers
      }
    })
})
